import {
  darkBlue,
  green,
  lightBlue,
  orange,
  red,
} from "../../../utils/theme/colors.ts";

export const userGroupColors: any = {
  admin: green,
  operations: darkBlue,
  cja: red,
  observer: orange,
  assistant: lightBlue,
};
